import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';

interface IImageProps {
  image: string;
  alt: string;
}

export const Image: React.FC<IImageProps> = ({ image, alt }) => (
  <div>
    <ResponsiveImage
      src={image}
      alt={alt}
      width={1024}
      height={512}
      objectFit="cover"
    />
  </div>
);
